import { render, staticRenderFns } from "./EstoqueConfirmRecebimento.vue?vue&type=template&id=4264f70c&"
import script from "./EstoqueConfirmRecebimento.vue?vue&type=script&lang=js&"
export * from "./EstoqueConfirmRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports